export default {"src":"/_next/static/media/menu.17721edd.svg","height":67,"width":68,"blurWidth":0,"blurHeight":0};